import SmartAccountExport from './SmartAccountExport'

export default SmartAccountExport
